import { DataModel } from "common/models/utility-models/base-model"

export class BranchesModel extends DataModel {
   
    department_name:any=''
    branchCategoryId:any=''
}